import { action, observable } from 'mobx';
import { mdiAlertCircleOutline, mdiCheckBold, mdiCloseCircle, mdiInformationOutline } from '@mdi/js';

export interface INotificationProps {
  type: string;
  message: string;
  header: string;
  hidden: boolean;
  timestamp: Date | undefined;
  children?: React.ReactNode;
}

interface INotification {
  header: string;
  iconPath: string;
  iconColor: string;
}

type NotificationType = 'success' | 'warn' | 'warning' | 'error' | 'default'| 'information';

export class NotificationVM {
  @observable props: INotificationProps;
  constructor(props: INotificationProps) {
    this.props = props;
  }

  @observable hidden: boolean = true;

  @observable notifications: Record<NotificationType, INotification> = {
    success: { header: 'Success!', iconPath: mdiCheckBold, iconColor: 'white' },
    warn: { header: 'Warning!', iconPath: mdiAlertCircleOutline, iconColor: 'rgb(0, 0, 128)' },
    warning: { header: 'Warning!', iconPath: mdiAlertCircleOutline, iconColor: 'rgb(0, 0, 128)' },
    information: { header: 'Alert!', iconPath: mdiInformationOutline, iconColor: '#183f6e' },
    error: { header: 'Error!', iconPath: mdiCloseCircle, iconColor: 'white' },
    default: { header: 'Alert!', iconPath: mdiInformationOutline, iconColor: '#183f6e' },
  };

  @action.bound setHidden(bool: boolean) {
    this.hidden = bool;
  }

  @action.bound getClass(type: string) {
    if (this.notifications[type]) {
      return 'notification-' + type;
    } else {
      return 'notification-default';
    }
  }

  @action.bound getDefaultHeader(type: string) {
    if (this.notifications[type]) {
      return this.notifications[type].header;
    } else {
      return this.notifications.default.header;
    }
  }

  @action.bound getIconPath(type: string) {
    if (this.notifications[type]) {
      return this.notifications[type].iconPath;
    } else {
      return this.notifications.default.iconPath;
    }
  }

  @action.bound getIconColor(type: string) {
    if (this.notifications[type]) {
      return this.notifications[type].iconColor;
    } else {
      return this.notifications.default.iconColor;
    }
  }
}
